import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import useWorkspaceAccessControl from '@/components/WorkspaceAccessControl/hooks/useWorkspaceAccessControl';
import { WorkspaceActions, WorkspaceSubjects } from '@/types/schema';

const subject = WorkspaceSubjects.Category;

export default function useCategoryPermissions(subjectLabel?: string) {
  const { isAccessible, showPermissionSnackbar } = useWorkspaceAccessControl();
  const { t } = useTranslation();

  const permissions = React.useMemo(
    () => ({
      canCreate: isAccessible(WorkspaceActions.Create, subject),
      canEdit: isAccessible(WorkspaceActions.Edit, subject),
      canRead: isAccessible(WorkspaceActions.Read, subject),
      canRemove: isAccessible(WorkspaceActions.Remove, subject),
    }),
    [isAccessible],
  );

  const showPermissionError = React.useCallback(
    (actionVerb: string) =>
      showPermissionSnackbar(actionVerb, subjectLabel ?? t('Discover:categories')),
    [showPermissionSnackbar, subjectLabel, t],
  );

  return { permissions, showPermissionError };
}
